<h3-right-collapsing-panel>
  <div class="menu-bar" projection-location="menu-bar">
    <a (click)="closeTagEditor()" class="btn btn-default btn-xs close-button">
      <fa-icon [icon]="faArrowLeft" [fixedWidth]="true"></fa-icon>
    </a>
    <div class="menu-bar-text">
      <div class="shape-index">
        Shape {{ (this.focusedShapeStore$ | async)?.state()?.index }}
      </div>
      <div *ngIf="maxFrameNumber$ | async" class="frame-number">
        Frame {{ frameNumber$ | async }}
      </div>
    </div>
    <h3-key-location-actions
      *ngIf="maxFrameNumber$ | async"
    ></h3-key-location-actions>
  </div>
  <ng-container *ngIf="(this.focusedShapeStore$ | async)?.state()">
    <mat-tab-group
      class="tag-editor"
      *ngIf="needsTabs$ | async"
      (selectedTabChange)="tabSelected($event)"
      [selectedIndex]="selectedTabIndex$ | async"
    >
      <mat-tab label="Static">
        <div
          h3TrackScrollEvents="tag_editor_static_tab"
          class="content"
          h3ScrollEnabler
        >
          <h3-objectless-nested-output-panel
            [dynamic]="false"
          ></h3-objectless-nested-output-panel>
        </div>
      </mat-tab>
      <mat-tab label="Dynamic">
        <div
          h3TrackScrollEvents="tag_editor_dynamic_tab"
          class="content"
          h3ScrollEnabler
        >
          <h3-objectless-nested-output-panel
            [dynamic]="true"
          ></h3-objectless-nested-output-panel>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div
      *ngIf="(needsTabs$ | async) === false"
      h3TrackScrollEvents="tag_editor_no_tabs"
      class="content"
      h3ScrollEnabler
    >
      <h3-objectless-nested-output-panel></h3-objectless-nested-output-panel>
    </div>
  </ng-container>
</h3-right-collapsing-panel>
